var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      staticClass: "icon_img",
      staticStyle: { height: "100px" },
      attrs: {
        src: require("../../../static/images/icon/NEEWER_Control-app-icon-optimized-9b9ab116-d204-4754-b3ac-fc8876f57c6a.png"),
      },
    }),
    _c("div", { staticClass: "app_desc" }, [
      _vm._v(
        "功能描述：neewer control center windows安装包上传页面，提供给neewer support center供客户下载"
      ),
    ]),
    _vm._m(0),
    _c("div", { staticClass: "app_desc" }, [
      _vm._v("注意：上传包的名称即为下载安装包名称，请勿中文命名"),
    ]),
    _c("div", { staticClass: "app_desc" }, [
      _vm._v("当前版本安装包下载路径：" + _vm._s(_vm.packageUrl)),
    ]),
    _c("div", { staticClass: "app_desc" }, [
      _vm._v("上次更新时间：" + _vm._s(_vm.updateTime)),
    ]),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "app_desc" },
      [
        _c(
          "a-upload",
          {
            staticClass: "avatar-uploader",
            attrs: {
              name: "avatar",
              "list-type": "picture-card",
              "show-upload-list": false,
              action: _vm.uploadOss,
              "before-upload": _vm.beforeUpload,
            },
            on: { change: _vm.handleChange },
          },
          [
            _c(
              "div",
              [
                _c("a-icon", {
                  attrs: { type: _vm.loading ? "loading" : "plus" },
                }),
                _c("div", { staticClass: "ant-upload-text" }, [
                  _vm._v(" " + _vm._s(_vm.process) + " "),
                ]),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app_desc" }, [
      _vm._v("neewer 用户使用下载页面地址："),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://support.neewer.com/neewer_control_center_detail?menu=1",
          },
        },
        [_vm._v("点击打开")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app_desc" }, [
      _c("p", [_vm._v("点击下图上传更新")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }